
import { useLanguage } from "@/contexts/LanguageContext";
import { translations } from "@/translations";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Percent, CircleDollarSign } from "lucide-react";
import { campPrices } from "@/config/prices";

const PricingTable = () => {
  const { language } = useLanguage();
  const t = translations[language].summerCamp.pricing;

  return (
    <div className="bg-card rounded-xl shadow-md overflow-hidden">
      <Table className="rounded-none bg-accent/20">
        <TableHeader>
          <TableRow>
            <TableHead className="w-[120px]"></TableHead>
            <TableHead>{t.weeks.oneWeek}</TableHead>
            <TableHead>{t.weeks.twoWeeks}</TableHead>
            <TableHead>{t.weeks.fourWeeks}</TableHead>
            <TableHead>{t.weeks.fiveWeeks}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow>
            <TableCell className="font-medium">{t.members}</TableCell>
            <TableCell>{campPrices.members.oneWeek}</TableCell>
            <TableCell>{campPrices.members.twoWeeks}</TableCell>
            <TableCell>{campPrices.members.fourWeeks}</TableCell>
            <TableCell>{campPrices.members.fiveWeeks}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="font-medium">{t.nonMembers}</TableCell>
            <TableCell>{campPrices.nonMembers.oneWeek}</TableCell>
            <TableCell>{campPrices.nonMembers.twoWeeks}</TableCell>
            <TableCell>{campPrices.nonMembers.fourWeeks}</TableCell>
            <TableCell>{campPrices.nonMembers.fiveWeeks}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
      
      <div className="p-6 bg-muted/50">
        <h5 className="font-medium text-lg mb-4 text-primary flex items-center gap-2">
          <CircleDollarSign className="w-5 h-5" />
          {language === 'es' ? 'Opciones adicionales' : 
           language === 'pt' ? 'Opções adicionais' : 
           language === 'fr' ? 'Options supplémentaires' : 
           'Additional options'}
        </h5>
        <div className="grid md:grid-cols-2 gap-6">
          <div className="bg-background rounded-lg p-4 shadow-sm">
            <h6 className="font-medium text-primary/90 mb-2">{t.options.lunch}</h6>
            <div className="space-y-2">
              <div className="flex justify-between items-center text-sm border-b border-border pb-2">
                <span className="text-muted-foreground">{t.labels.daily}:</span>
                <span className="font-medium">{campPrices.options.lunch.daily}</span>
              </div>
              <div className="flex justify-between items-center text-sm border-b border-border pb-2">
                <span className="text-muted-foreground">{t.labels.weekly}:</span>
                <span className="font-medium">{campPrices.options.lunch.weekly}</span>
              </div>
              <div className="flex justify-between items-center text-sm">
                <span className="text-muted-foreground">{t.labels.monthly}:</span>
                <span className="font-medium">{campPrices.options.lunch.monthly}</span>
              </div>
            </div>
          </div>

          <div className="bg-background rounded-lg p-4 shadow-sm">
            <div className="space-y-4">
              <div>
                <h6 className="font-medium text-primary/90 mb-2">{t.options.earlyDropoff}</h6>
                <div className="flex justify-between items-center text-sm">
                  <span className="text-muted-foreground">{t.labels.perSection}:</span>
                  <span className="font-medium">{campPrices.options.earlyDropoff}</span>
                </div>
              </div>
              <div>
                <h6 className="font-medium text-primary/90 mb-2">{t.options.latePickup}</h6>
                <div className="flex justify-between items-center text-sm">
                  <span className="text-muted-foreground">{t.labels.perSection}:</span>
                  <span className="font-medium">{campPrices.options.latePickup}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="p-4 bg-primary/10 flex items-center space-x-4">
        <Percent className="text-primary w-6 h-6" />
        <div>
          <p className="font-medium text-primary">{t.discounts.title}</p>
          <p className="text-sm text-muted-foreground">{t.discounts.secondChild}</p>
          <p className="text-sm text-muted-foreground">{t.discounts.thirdChild}</p>
        </div>
      </div>
    </div>
  );
};

export default PricingTable;
